import { Routes } from '@angular/router';
import { AppDeciderComponent } from '../layouts/app-decider/app-decider.component';
import { canActivateAuthorization } from '../security/authorization.guard';
import { GrundstueckFormService } from '../grundstueck/grundstueck-form-service';
import { GrundstueckRubrikService } from '../grundstueck/grundstueck-rubriken/grundstueck-rubrik.service';
import { PermissionResponse } from '../core/base-api';
import { GrundstueckIcpDetailComponent } from './grundstueck-icp/grundstueck-icp-detail.component';
import { MeineGrundstueckeIcpComponent } from './meine-grundstuecke-icp/meine-grundstuecke-icp.component';
import { icpParamRequiredGuard } from './icp-param-required.guard';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

export const ICPRoutes: Routes = [
  {
    path: 'grundstueck',
    pathMatch: 'prefix',
    component: AppDeciderComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.LOGIN, PermissionsEnum.ICP_AUTHORIZED, PermissionsEnum.ANONYM]
    },
    children: [
      {
        path: '',
        loadChildren: () => routes,
        providers: [GrundstueckFormService, GrundstueckRubrikService]
      }
    ]
  }
];

const routes: Routes = [
  {
    path: 'es',
    component: GrundstueckIcpDetailComponent,
    canActivate: [canActivateAuthorization, icpParamRequiredGuard],
    data: {
      permissions: [PermissionsEnum.ICP_AUTHORIZED, PermissionsEnum.ANONYM]
    }
  },
  {
    path: 'meine-grundstuecke',
    component: MeineGrundstueckeIcpComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.ICP_AUTHORIZED, PermissionsEnum.ANONYM]
    }
  }
];
